(function () {
  'use strict';

  if (window.DJWSSharedExperience) return;
  window.DJWSSharedExperience = { version: '1.0.0' };
  document.documentElement.classList.add('djws-has-js');

  function each(selector, callback, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(selector), callback);
  }

  function initNavigation(nav) {
    var toggle = nav.querySelector('[data-djws-nav-toggle]');
    var links = nav.querySelector('[data-djws-nav-links]');
    if (!toggle || !links) return;

    var media = window.matchMedia('(max-width: 749px)');

    function setOpen(open, restoreFocus) {
      links.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      nav.classList.toggle('is-open', open);
      if (restoreFocus) toggle.focus();
    }

    function syncForViewport() {
      if (media.matches) {
        toggle.hidden = false;
        setOpen(false, false);
      } else {
        toggle.hidden = true;
        links.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        nav.classList.remove('is-open');
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true', false);
    });

    links.addEventListener('click', function (event) {
      if (media.matches && event.target.closest('a')) setOpen(false, false);
    });

    nav.addEventListener('keydown', function (event) {
      if (media.matches && event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setOpen(false, true);
      }
    });

    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', syncForViewport);
    } else if (typeof media.addListener === 'function') {
      media.addListener(syncForViewport);
    }

    syncForViewport();
  }

  function closeKjDialog(dialog, restoreFocus) {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.classList.remove('is-fallback-open');
      document.body.classList.remove('djws-dialog-open');
      if (restoreFocus && dialog._djwsTrigger) dialog._djwsTrigger.focus();
    }
  }

  function openKjDialog(dialog, trigger) {
    dialog._djwsTrigger = trigger;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.classList.add('is-fallback-open');
    }
    document.body.classList.add('djws-dialog-open');
    var closeButton = dialog.querySelector('[data-djws-dialog-close]');
    if (closeButton) window.requestAnimationFrame(function () { closeButton.focus(); });
  }

  function initKjDialog(dialog) {
    var id = dialog.id;
    if (!id) return;
    var trigger = document.querySelector('[data-djws-dialog-open="' + id + '"]');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      openKjDialog(dialog, trigger);
    });

    each('[data-djws-dialog-close]', function (button) {
      button.addEventListener('click', function () { closeKjDialog(dialog, true); });
    }, dialog);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeKjDialog(dialog, true);
    });

    dialog.addEventListener('cancel', function () {
      document.body.classList.remove('djws-dialog-open');
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('djws-dialog-open');
      if (dialog._djwsTrigger) dialog._djwsTrigger.focus();
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && typeof dialog.showModal !== 'function') {
        event.preventDefault();
        closeKjDialog(dialog, true);
      }
    });
  }

  var songIndexRequests = {};

  function loadJson(url) {
    if (!songIndexRequests[url]) {
      songIndexRequests[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('DJWS index request failed');
        return response.json();
      });
    }
    return songIndexRequests[url];
  }

  function itemHandle(item) {
    if (!item) return '';
    if (typeof item === 'string') return item;
    if (item.handle) return item.handle;
    if (item.system && item.system.handle) return item.system.handle;
    if (item.url) {
      var parts = String(item.url).split('?')[0].split('#')[0].split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    }
    return '';
  }

  function itemHandles(items) {
    return (Array.isArray(items) ? items : []).map(itemHandle).filter(Boolean);
  }

  function titleForSong(song) {
    return song && (song.song_title_only || song.title || song.songTitle || song.handle) || '';
  }

  function internalUrl(value, fallback) {
    try {
      var url = new URL(value || fallback, window.location.origin);
      if (url.origin !== window.location.origin) return fallback;
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return fallback;
    }
  }

  function formatDuration(seconds) {
    var value = Number(seconds);
    if (!value || value < 1) return '';
    var minutes = Math.floor(value / 60);
    var remainder = value % 60;
    return minutes + ':' + (remainder < 10 ? '0' : '') + remainder;
  }

  function makeSongList(songs) {
    var list = document.createElement('ul');
    list.className = 'djws-related-list';

    songs.forEach(function (song) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      var fallback = '/pages/djws-song/' + encodeURIComponent(song.handle || '');
      link.href = internalUrl(song.url, fallback);
      link.textContent = titleForSong(song);
      item.appendChild(link);

      var details = [];
      if (song.year) details.push(song.year);
      if (song.duration) details.push(formatDuration(song.duration));
      if (details.length) {
        var meta = document.createElement('span');
        meta.textContent = details.join(' · ');
        item.appendChild(meta);
      }
      list.appendChild(item);
    });

    return list;
  }

  function makeContextCard(title, songs, album) {
    var card = document.createElement('section');
    card.className = 'djws-context-card';
    var heading = document.createElement('h2');
    heading.textContent = title;
    card.appendChild(heading);

    if (album) {
      var albumLink = document.createElement('a');
      albumLink.className = 'djws-context-card__album';
      albumLink.href = internalUrl(album.url, '/pages/djws-albums/' + encodeURIComponent(album.handle || ''));
      albumLink.textContent = 'View ' + (album.name || album.title || 'album');
      card.appendChild(albumLink);
    }

    card.appendChild(makeSongList(songs));
    return card;
  }

  function sharedCount(a, b) {
    var right = new Set(b);
    return a.reduce(function (count, value) { return count + (right.has(value) ? 1 : 0); }, 0);
  }

  function scoreRelated(current, candidate) {
    var score = 0;
    score += sharedCount(itemHandles(current.themes), itemHandles(candidate.themes)) * 4;
    score += sharedCount(itemHandles(current.genres || current.primaryGenres), itemHandles(candidate.genres || candidate.primaryGenres)) * 2;
    if (current.year && candidate.year) {
      var distance = Math.abs(Number(current.year) - Number(candidate.year));
      if (distance === 0) score += 2;
      else if (distance <= 3) score += 1;
    }
    return score;
  }

  function findArtistEntry(index, handle) {
    if (index[handle]) return index[handle];
    var entries = Object.keys(index).map(function (key) { return index[key]; });
    return entries.find(function (entry) { return entry && entry.artistHandle === handle; });
  }

  function parseServerAlbumHandles(root) {
    var node = root.querySelector('[data-djws-song-album-handles]');
    if (!node) return [];
    try {
      var value = JSON.parse(node.textContent);
      return Array.isArray(value) ? value.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function renderSongContext(root, index) {
    var artistHandle = root.getAttribute('data-artist-handle') || '';
    var songHandle = root.getAttribute('data-song-handle') || '';
    var artistName = root.getAttribute('data-artist-name') || 'this artist';
    var artistEntry = findArtistEntry(index, artistHandle);
    var songs = artistEntry && Array.isArray(artistEntry.songs) ? artistEntry.songs : [];
    if (!songs.length) return;

    var current = songs.find(function (song) {
      return song && (song.handle === songHandle || String(song.url || '').split('?')[0].endsWith('/' + songHandle));
    });
    if (!current) return;

    var albumHandles = Array.from(new Set(parseServerAlbumHandles(root).concat(itemHandles(current.albums))));
    var sameAlbum = songs.filter(function (song) {
      return song !== current && sharedCount(itemHandles(song.albums), albumHandles) > 0;
    }).sort(function (a, b) { return titleForSong(a).localeCompare(titleForSong(b)); }).slice(0, 5);

    var excluded = new Set(sameAlbum.map(function (song) { return song.handle; }));
    var related = songs.filter(function (song) {
      return song !== current && !excluded.has(song.handle);
    }).sort(function (a, b) {
      var score = scoreRelated(current, b) - scoreRelated(current, a);
      return score || titleForSong(a).localeCompare(titleForSong(b));
    }).slice(0, 6);

    if (!sameAlbum.length && !related.length) return;

    var grid = document.createElement('div');
    grid.className = 'djws-context-grid';

    if (sameAlbum.length) {
      var currentAlbums = Array.isArray(current.albums) ? current.albums : [];
      var album = currentAlbums.find(function (candidate) {
        return albumHandles.indexOf(itemHandle(candidate)) !== -1;
      }) || currentAlbums[0] || null;
      grid.appendChild(makeContextCard('More from this album', sameAlbum, album));
    }

    if (related.length) {
      grid.appendChild(makeContextCard('More by ' + artistName, related, null));
    }

    root.replaceChildren(grid);
    root.hidden = false;
  }

  function initSongContext(root) {
    var url = root.getAttribute('data-index-url');
    if (!url) return;
    var start = function () {
      loadJson(url).then(function (index) { renderSongContext(root, index); }).catch(function () {
        root.hidden = true;
      });
    };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(start, { timeout: 1200 });
    } else {
      window.setTimeout(start, 1);
    }
  }

  each('[data-djws-nav]', initNavigation);
  each('[data-djws-kj-dialog]', initKjDialog);
  each('[data-djws-song-context]', initSongContext);
})();
